/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentSelect from './AppointmentSelect/index'
import LocationSelect from './LocationSelect/index'
import MoreSchedulingOptions from './MoreSchedulingOptions/index'
import React from 'react'
import TreatmentSelect from './TreatmentSelect/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content"
  
}) {
let displayPatientOptionsValueData = fromData.useDataValue({ viewPath,
context: 'display_patient_options',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<MoreSchedulingOptions
  viewPath={`${viewPath}/MoreSchedulingOptions`}
/>
</div>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-5-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-6-Z1Yf8zk': dtColorsWhite,'--d-7-Z1Yf8zk': displayPatientOptionsValueData ? "flex" : "none"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TreatmentSelect
  viewPath={`${viewPath}/TreatmentSelect`}
/>
<AppointmentSelect
  viewPath={`${viewPath}/AppointmentSelect`}
/>
</div>
<LocationSelect
  viewPath={`${viewPath}/LocationSelect`}
/>
</div>
{children}
</React.Fragment>)
}